export default __webpack_public_path__ + "static/media/2207.328e9a42.png";